import {
  ParametersMessage,
  JackpotHitMessage,
  JackpotHistoryMessage,
  ProgressiveCurValuesMessage,
} from "../models/Messages";

const CommonEvents = {
  UPDATED_CONFIG: "UPDATED_CONFIG",
  UPDATED_GAME_INFO: "UPDATED_GAME_INFO",
  CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
  CHANGE_THEME: "CHANGE_THEME",
} as const;

const MessageEvents = {
  MESSAGE_PARAMETERS: "MESSAGE_PARAMETERS",
  MESSAGE_PROGRESSIVE_CUR_VALUES: "MESSAGE_PROGRESSIVE_CUR_VALUES",
  MESSAGE_JACKPOT_HIT: "MESSAGE_JACKPOT_HIT",
  MESSAGE_JACKPOT_HISTORY: "MESSAGE_JACKPOT_HISTORY",
};

const GameEvents = {
  JACKPOT_HISTORY_UPDATED: "JACKPOT_HISTORY_UPDATED",
};

export type MessageEventMap = {
  [MessageEvents.MESSAGE_PARAMETERS]: [msg: ParametersMessage];
  [MessageEvents.MESSAGE_JACKPOT_HIT]: [msg: JackpotHitMessage];
  [MessageEvents.MESSAGE_JACKPOT_HISTORY]: [msg: JackpotHistoryMessage];
  [MessageEvents.MESSAGE_PROGRESSIVE_CUR_VALUES]: [
    msg: ProgressiveCurValuesMessage,
  ];
};

export { CommonEvents, MessageEvents, GameEvents };
